(function () {
    'use strict';
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;

    // Link transferu (#mk=) i parametry analizatora są prywatne także dla pomiaru.
    function publicznyAdres(adres) {
        try { var u = new URL(adres); return u.origin + u.pathname; } catch (e) { return ''; }
    }
    gtag('set', { page_location: publicznyAdres(location.href), page_referrer: publicznyAdres(document.referrer) });

    gtag('consent', 'default', {
        'ad_storage':         'denied',
        'ad_user_data':       'denied',
        'ad_personalization': 'denied',
        'analytics_storage':  'denied',
        'wait_for_update':    2000
    });

    // „Ustawienia prywatnosci" w stopce (polityka cookies §7.2): otwiera panel
    // ponownej decyzji CMP Google, jesli loader AdSense go dostarczyl. Bez CMP
    // (ENV=test, ?ads=0) link zachowuje sie jak zwykly odnosnik do polityki.
    function otworzUstawienia(e) {
        var fc = window.googlefc;
        if (fc && typeof fc.showRevocationMessage === 'function') {
            if (e) { e.preventDefault(); }
            fc.showRevocationMessage();
        }
    }
    document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[href$="#ustawienia"]') : null;
        if (!a) { return; }
        var url = new URL(a.href, location.href);
        if (url.origin === location.origin && ['/polityka/cookies', '/en/cookies-policy'].indexOf(url.pathname.replace(/\/$/, '')) !== -1) {
            otworzUstawienia(e);
        }
    });
    if (location.hash === '#ustawienia') {
        window.googlefc = window.googlefc || {};
        window.googlefc.callbackQueue = window.googlefc.callbackQueue || [];
        window.googlefc.callbackQueue.push({ 'CONSENT_DATA_READY': function () { otworzUstawienia(null); } });
    }
})();
